<div *ngIf="dataSource && dataSource.data.length > 0" class="table-responsive m-t-30">
    <table mat-table
        [dataSource]="dataSource"
        matSort
        matSortDirection="desc"
        matSortActive="financedAmount">

         <ng-container matColumnDef="amount">
             <th mat-header-cell *matHeaderCellDef class="th-title">
                Monto
             </th>
             <td mat-cell *matCellDef="let element" class="td-text-content">
                 <h6>{{ element.amount | currency:'CLP':'symbol' }}</h6>
             </td>
         </ng-container>

         <ng-container matColumnDef="cost">
             <th mat-header-cell *matHeaderCellDef class="th-title">
                Comisión
             </th>
             <td mat-cell *matCellDef="let element" >
                 <h6>{{ element.cost | currency:'CLP':'symbol' }}</h6>
             </td>
         </ng-container>

         <ng-container matColumnDef="createdAt">
             <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title id-date">
                Inicio
             </th>
             <td mat-cell *matCellDef="let element" class="td-text-content id-date">
                 <h6>{{ element.createdAt | date : "dd/MM/yyyy" }}</h6>
             </td>
         </ng-container>

         <ng-container matColumnDef="endDate">
             <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title id-date">
                Término
             </th>
             <td mat-cell *matCellDef="let element" class="td-text-content id-date">
                 <span>{{ element.endDate | date : "dd/MM/yyyy" }}</span>
             </td>
         </ng-container>

         <ng-container matColumnDef="insuranceBroker">
             <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                Corredor
             </th>
             <td mat-cell *matCellDef="let element" class="td-text-content">
                 <h6>{{ element.insuranceBroker }}</h6>
             </td>
         </ng-container>

         <ng-container matColumnDef="insuranceCompany">
             <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                Emisor
             </th>
             <td mat-cell *matCellDef="let element" class="td-text-content">
                 <h6>{{ element.insuranceCompany }}</h6>
             </td>
         </ng-container>

         <ng-container matColumnDef="nameTenderBuyer">
             <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                Mandante
             </th>
             <td mat-cell *matCellDef="let element" class="td-text-content">
                 <h6>{{ element.nameTenderBuyer }}</h6>
             </td>
         </ng-container>

         <ng-container matColumnDef="tender">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                Licitación
            </th>
            <td mat-cell *matCellDef="let element" class="td-text-content">
                <h6>{{ element.tender }}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="warrantyType">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                Finalidad
            </th>
            <td mat-cell *matCellDef="let element" class="td-text-content">
                <h6>{{ element.warrantyType }}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="isBuild">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                Construcción
            </th>
            <td mat-cell *matCellDef="let element" class="td-text-content">
                <h6>{{ element.isBuild ? 'Si' : 'No' }}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="contractAmount">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                Tamaño Contrato
            </th>
            <td mat-cell *matCellDef="let element" class="td-text-content">
                <h6>{{ element.contractAmount | currency:'CLP':'symbol' }}</h6>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedCols"></tr>
        <tr mat-row class="cursor-row" [cdkContextMenuTriggerFor]="menu" *matRowDef="let row; columns: displayedCols">
        <ng-template #menu>
            <div cdkMenu class="context_menu mat-elevation-z8">
                <button (click)="removeWarranty(row)" cdkMenuItem class="menu-item" mat-raised-button>
                    Quitar
                </button><br>

                <button (click)="openModalConstruccionWarrantie(row)" cdkMenuItem class="menu-item" mat-raised-button>
                    Cambiar es Construcción
                </button>
            </div>
        </ng-template>
        </tr>
    </table>
</div>
<span *ngIf="!dataSource || dataSource.data.length == 0">
    <h3 style="font-weight: normal;">Sin Garantias a evaluar</h3>
</span>